import * as React from 'react';

import {DurationTimestamp} from '../../../../timestamp/duration-timestamp';

import {SessionPageItem} from './session-page-item';
import type {SessionPage} from './session-page-item';

import styles from './session-content.module.css';

export type Page = SessionPage;

type Props = {
    durationSeconds: number;
    source: {
        medium: string;
        source: string;
    };
    pages: Page[];
};

export function SessionContent(props: Props) {
    const {durationSeconds, pages} = props;
    const {source, medium} = props.source;

    return (
        <div>
            <dl className={styles['utm-data-container']}>
                <div className={styles['utm-data']}>
                    <dt>
                        <strong>utm_source</strong>
                    </dt>
                    <dd>{source}</dd>
                </div>
                <div className={styles['utm-data']}>
                    <dt>
                        <strong>utm_medium</strong>
                    </dt>
                    <dd>{medium}</dd>
                </div>
            </dl>
            <div className={styles['page-data-container']}>
                <div className={styles['page-data-header']}>
                    <strong>
                        {pages.length} page{pages.length !== 1 ? 's' : ''}
                    </strong>
                    <strong>
                        <DurationTimestamp durationSeconds={durationSeconds} />
                    </strong>
                </div>
                {pages.map((page) => (
                    <SessionPageItem key={page.id} page={page} />
                ))}
            </div>
        </div>
    );
}
